import { CurrentState, OfflineUpdateSummary } from "./OfflineUpdateSummary";
import DownloadIndicator from "./DownloadIndicator";
import { BackendServerAvailability } from "../appinitandstate/BackendServerAvailability";
import { DownloadNecessaryButNoBackendAvailabilityNotification } from "./DownloadNecessaryButNoBackendAvailabilityNotification";
import { DownloadNecessaryNotification } from "./DownloadNecessaryNotification";

interface Props {
  currentBackendServerAvailability: BackendServerAvailability;
  startUpdate: () => void;
  resetProgress: () => void;
  offlineUpdateSummary: OfflineUpdateSummary;
  downloadOfFilesNecessary: boolean;
}

export default function OfflineComponentsHolder(props: Props) {
  return (
    <>
      {props.offlineUpdateSummary.currentState !== CurrentState.NOT_RUNNING ? (
        <>
          <DownloadIndicator
            offlineUpdateSummary={props.offlineUpdateSummary}
            resetProgress={props.resetProgress}
          />
        </>
      ) : (
        props.downloadOfFilesNecessary && (
          <>
            {props.currentBackendServerAvailability ===
            BackendServerAvailability.Available ? (
              <>
                <DownloadNecessaryNotification
                  startUpdate={props.startUpdate}
                />
              </>
            ) : (
              <>
                <DownloadNecessaryButNoBackendAvailabilityNotification />
              </>
            )}
          </>
        )
      )}
    </>
  );
}
